module.exports = __webpack_public_path__ + "img/image76.4286e566.png";